module.exports = "/_next/static/images/HipaaCompliantBadge@2x-c35b0b64ed8e1c9c49c5964d25019be1.webp";